import  Map  from "./Map";
import React from "react";
import SlideMap from "./SlideMap";
import useFetch from "../../../../commons/useFetch";
function MapHome() {
  const key = "AIzaSyAwUUGIMXTOZEX_rtcZj1IyvTOqsA2sts4";
  const {data : hotels}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels')
  return (
    <div id="mapHome">
      <div className="container">
        <h5 className="titleStyle">Điểm đến</h5>
      </div>
      <Map
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={
          <div
            style={{
              height: `500px`,
              margin: `auto`,
            }}
          />
        }
        hotels={hotels}
        mapElement={<div style={{ height: `100%` }} />}
      />
      <SlideMap />
    </div>
  );
}
export default MapHome;
